/** 分会首页功能性图片轮播（后台 CMS：branch_home_hero） */

export const BRANCH_HOME_HERO_COLUMN = 'branch_home_hero'

export const BRANCH_HOME_CAROUSEL_INTERVAL = 5000
